/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { GeometryLabelDto } from './GeometryLabelDto';
import {
    GeometryLabelDtoFromJSON,
    GeometryLabelDtoFromJSONTyped,
    GeometryLabelDtoToJSON,
} from './GeometryLabelDto';
import type { CreateDefinitionParameterDtoValueType } from './CreateDefinitionParameterDtoValueType';
import {
    CreateDefinitionParameterDtoValueTypeFromJSON,
    CreateDefinitionParameterDtoValueTypeFromJSONTyped,
    CreateDefinitionParameterDtoValueTypeToJSON,
} from './CreateDefinitionParameterDtoValueType';
import type { RtSystemQuantityScopeDto } from './RtSystemQuantityScopeDto';
import {
    RtSystemQuantityScopeDtoFromJSON,
    RtSystemQuantityScopeDtoFromJSONTyped,
    RtSystemQuantityScopeDtoToJSON,
} from './RtSystemQuantityScopeDto';

/**
 * 
 * @export
 * @interface SetupQuantityUsageDto
 */
export interface SetupQuantityUsageDto {
    /**
     * 
     * @type {string}
     * @memberof SetupQuantityUsageDto
     */
    id: string;
    /**
     * 
     * @type {CreateDefinitionParameterDtoValueType}
     * @memberof SetupQuantityUsageDto
     */
    valueType?: CreateDefinitionParameterDtoValueType | null;
    /**
     * 
     * @type {number}
     * @memberof SetupQuantityUsageDto
     */
    decimalPlaces?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SetupQuantityUsageDto
     */
    inputRangeMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SetupQuantityUsageDto
     */
    inputRangeMax?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SetupQuantityUsageDto
     */
    unitId?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SetupQuantityUsageDto
     */
    readonly creatorUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SetupQuantityUsageDto
     */
    readonly creationTime?: string;
    /**
     * 
     * @type {number}
     * @memberof SetupQuantityUsageDto
     */
    readonly lastModifierUserId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof SetupQuantityUsageDto
     */
    lastModificationTime?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SetupQuantityUsageDto
     */
    isUsageEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SetupQuantityUsageDto
     */
    useSetupGeometry?: boolean;
    /**
     * 
     * @type {Array<RtSystemQuantityScopeDto>}
     * @memberof SetupQuantityUsageDto
     */
    medicalSystemScope?: Array<RtSystemQuantityScopeDto> | null;
    /**
     * 
     * @type {Array<RtSystemQuantityScopeDto>}
     * @memberof SetupQuantityUsageDto
     */
    qaEquipmentScope?: Array<RtSystemQuantityScopeDto> | null;
    /**
     * 
     * @type {Array<GeometryLabelDto>}
     * @memberof SetupQuantityUsageDto
     */
    setupGeometries?: Array<GeometryLabelDto> | null;
    /**
     * 
     * @type {string}
     * @memberof SetupQuantityUsageDto
     */
    $type?: SetupQuantityUsageDtoTypeEnum;
}


/**
 * @export
 */
export const SetupQuantityUsageDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedDataTypeManagementDtoNumericDtoSetupQuantityUsageDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.DataTypeManagement.Dto.NumericDto.SetupQuantityUsageDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type SetupQuantityUsageDtoTypeEnum = typeof SetupQuantityUsageDtoTypeEnum[keyof typeof SetupQuantityUsageDtoTypeEnum];



/**
 * Check if a given object implements the SetupQuantityUsageDto interface.
 */
export function instanceOfSetupQuantityUsageDto(value?: unknown): value is SetupQuantityUsageDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(SetupQuantityUsageDtoTypeEnum)[0];
}

export function SetupQuantityUsageDtoFromJSON(json: any): SetupQuantityUsageDto {
    return SetupQuantityUsageDtoFromJSONTyped(json, false);
}

export function SetupQuantityUsageDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetupQuantityUsageDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'valueType': json['valueType'] == null ? undefined : CreateDefinitionParameterDtoValueTypeFromJSON(json['valueType']),
        'decimalPlaces': json['decimalPlaces'] == null ? undefined : json['decimalPlaces'],
        'inputRangeMin': json['inputRangeMin'] == null ? undefined : json['inputRangeMin'],
        'inputRangeMax': json['inputRangeMax'] == null ? undefined : json['inputRangeMax'],
        'unitId': json['unitId'] == null ? undefined : json['unitId'],
        'creatorUserId': json['creatorUserId'] == null ? undefined : json['creatorUserId'],
        'creationTime': json['creationTime'] == null ? undefined : json['creationTime'],
        'lastModifierUserId': json['lastModifierUserId'] == null ? undefined : json['lastModifierUserId'],
        'lastModificationTime': json['lastModificationTime'] == null ? undefined : json['lastModificationTime'],
        'isUsageEnabled': json['isUsageEnabled'] == null ? undefined : json['isUsageEnabled'],
        'useSetupGeometry': json['useSetupGeometry'] == null ? undefined : json['useSetupGeometry'],
        'medicalSystemScope': json['medicalSystemScope'] == null ? undefined : ((json['medicalSystemScope'] as Array<any>).map(RtSystemQuantityScopeDtoFromJSON)),
        'qaEquipmentScope': json['qaEquipmentScope'] == null ? undefined : ((json['qaEquipmentScope'] as Array<any>).map(RtSystemQuantityScopeDtoFromJSON)),
        'setupGeometries': json['setupGeometries'] == null ? undefined : ((json['setupGeometries'] as Array<any>).map(GeometryLabelDtoFromJSON)),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function SetupQuantityUsageDtoToJSON(value?: Omit<SetupQuantityUsageDto, 'creatorUserId'|'creationTime'|'lastModifierUserId'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value['id'],
        'valueType': CreateDefinitionParameterDtoValueTypeToJSON(value['valueType']),
        'decimalPlaces': value['decimalPlaces'],
        'inputRangeMin': value['inputRangeMin'],
        'inputRangeMax': value['inputRangeMax'],
        'unitId': value['unitId'],
        'lastModificationTime': value['lastModificationTime'],
        'isUsageEnabled': value['isUsageEnabled'],
        'useSetupGeometry': value['useSetupGeometry'],
        'medicalSystemScope': value['medicalSystemScope'] == null ? undefined : ((value['medicalSystemScope'] as Array<any>).map(RtSystemQuantityScopeDtoToJSON)),
        'qaEquipmentScope': value['qaEquipmentScope'] == null ? undefined : ((value['qaEquipmentScope'] as Array<any>).map(RtSystemQuantityScopeDtoToJSON)),
        'setupGeometries': value['setupGeometries'] == null ? undefined : ((value['setupGeometries'] as Array<any>).map(GeometryLabelDtoToJSON)),
        '$type': value['$type'],
    });
}

